
import { Component, Prop, Vue } from 'vue-property-decorator';

import GoogleMaps from '../../anonymous/GoogleMaps.vue';
import VendorLocations from '../vendor-location/VendorLocations.vue';
import ViewDocuments from '../document/ViewDocuments.vue';

import { sharedState } from '../../../../framework/state';
import { getResource } from '../../../../framework/client/resource';
import { getEnumerationOptions, getOptionLabel } from '../../../../framework/service/options';

import { VendorType } from '../../../../../common/application/model/enums/VendorType';
import { Vendor } from '../../../../../common/application/model/Vendor';
import { ApplicationResource } from '../../../../../common/application/enumeration/ApplicationResource';
import { InvoicePeriodizationType } from '../../../../../common/application/model/enums/InvoicePeriodizationType';
import EditVendor from './EditVendor.vue';
import { PeriodizationModel } from '../../../../../common/application/model/PeriodizationModel';
import { InvoicePeriodizationOffsetDirection } from '../../../../../common/application/model/enums/InvoicePeriodizationOffsetDirection';
import PeriodizationTypeSelector from '../../shared/PeriodizationTypeSelector.vue';

@Component({
    components: {
        VendorLocations,
        GoogleMaps,
        ViewDocuments,
        PeriodizationTypeSelector,
    },
    beforeRouteEnter(to: any, from: any, next: any) {
        next((vm: EditVendor) => {
            vm.getPrevRouter(from); //get the previous URL
        });
    },
})
export default class ViewVendor extends Vue {
    readonly resourceType = ApplicationResource.VENDOR;

    @Prop(String) readonly id!: string;

    shared = sharedState;
    local = {
        row: {} as Vendor,
        vendorTypeOptions: [] as { id: string | undefined; label: string }[],
        invoicePeriodizationTypeOptions: [] as { id: string | undefined; label: string }[],
        vendorType: '',
        activeTab: 0,
        prevRoute: '',
    };

    // Functions
    async mounted() {
        this.local.vendorTypeOptions = getEnumerationOptions('VendorType', Object.keys(VendorType), this);
        this.local.row = (await getResource<Vendor>(this.resourceType, this.id))!!;
        this.local.vendorType = getOptionLabel(this.local.row.vendorType, this.local.vendorTypeOptions);
        this.local.invoicePeriodizationTypeOptions = getEnumerationOptions(
            'InvoicePeriodizationType',
            Object.keys(InvoicePeriodizationType),
            this,
        );
    }

    back() {
        this.$router.go(-1);
    }

    edit() {
        this.$router.push(`/vendor/${this.local.row.id}/edit`);
    }

    addDocument() {
        this.$router.push({ name: 'EditVendor', params: { activeTab: this.local.activeTab } } as any);
    }

    get coords(): google.maps.LatLngLiteral {
        return {
            lat: this.local.row.lat,
            lng: this.local.row.lng,
        };
    }

    get fullAddress(): string {
        if (!this.local.row.vendorAddressStreet) {
            return '';
        }

        return `${this.local.row.vendorAddressStreet}, ${this.local.row.vendorAddressZip} ${this.local.row.vendorAddressCity}`;
    }

    get isAdmin(): boolean {
        return this.shared.admin;
    }

    get periodizationModel(): PeriodizationModel {
        return {
            type: this.local.row.invoicePeriodizationType,
            useOffset: this.local.row.invoicePeriodizationUseOffset ?? false,
            direction: this.local.row.invoicePeriodizationOffsetDirection ?? InvoicePeriodizationOffsetDirection.ADD,
            days: this.local.row.invoicePeriodizationOffsetDays ?? 0,
        };
    }

    getPrevRouter(from: any) {
        this.local.prevRoute = from.path;
        if (this.local.prevRoute.includes('/file-meta/')) {
            this.local.activeTab = 1;
        }
    }
}
